import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { KIND, SIZE } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import { selectNettingTarget } from './nettingUpdaterSelectors'
import NettingUpdaterForm from './NettingUpdaterForm'
import NettingFtpsForm from './NettingFtpsForm'
import NettingApiForm from './NettingApiForm'
import NettingBatchList from './NettingBatchList'
import { Card, Header2 } from '@/shared/theme/styled-components'
import { SideBySideRow, SideBySideColumn, HeaderRow, ProviderInfo } from './styled-components'
import { getNettingConfig } from './nettingConfig'

const NETTING_FORMS = {
  file_upload: NettingUpdaterForm,
  ftps: NettingFtpsForm,
  api: NettingApiForm,
}

const getFormComponent = mode => NETTING_FORMS[mode] || NettingUpdaterForm

const NettingUpdaterPage = () => {
  const { t } = useTranslation('organizationManagement')
  const target = useSelector(selectNettingTarget)
  const organizationProvider = useSelector(selectOrganizationsSelectedProvider)
  const selectedProvider = target ?? organizationProvider
  const navigate = useNavigate()

  const backendType = selectedProvider?.netting_process_type || 'file_upload'
  const ParticuliersForm = getFormComponent(backendType)

  const config = getNettingConfig(selectedProvider?.integration_technical_name)
  const ProForm = config.pro ? getFormComponent(config.pro) : null

  return (
    <Card>
      <Header2>{t('netting.page_title')}</Header2>

      <HeaderRow>
        <SDButton onClick={() => navigate(-1)} size={SIZE.mini} kind={KIND.secondary}>
          {t('netting.button_back')}
        </SDButton>
      </HeaderRow>

      <ProviderInfo>
        {t('netting.provider_label')}: <strong>{selectedProvider?.name || ''}</strong>
      </ProviderInfo>

      {ProForm ? (
        <SideBySideRow>
          <SideBySideColumn>
            <h3>{t('netting.section_particuliers')}</h3>
            <ParticuliersForm />
          </SideBySideColumn>
          <SideBySideColumn>
            <h3>{t('netting.section_pro')}</h3>
            <ProForm isPro />
          </SideBySideColumn>
        </SideBySideRow>
      ) : (
        <ParticuliersForm />
      )}

      <NettingBatchList />
    </Card>
  )
}

export default NettingUpdaterPage
